function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow-left_svg__clip0_1717:10022)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.42 17.835l.332-.331a.563.563 0 000-.796l-3.934-3.911h17.62c.31 0 .562-.252.562-.563v-.468a.563.563 0 00-.563-.563H4.817l3.935-3.911a.563.563 0 000-.796l-.332-.331a.562.562 0 00-.795 0l-5.46 5.437a.563.563 0 000 .796l5.46 5.437c.22.22.576.22.795 0z",
  fill: "#F8DC00"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-left_svg__clip0_1717:10022"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(2)",
  d: "M0 0h21v24H0z"
})));
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgArrowLeft;